<div *ngIf="show" class="alert-backdrop">
  <div class="alert-card" [class.alert-card--decision]="decision">
    <button
      *ngIf="decision"
      type="button"
      class="alert-close"
      aria-label="Cerrar alerta"
      (click)="onCancel.emit()"
    >
      <i class="pi pi-times"></i>
    </button>

    <div class="alert-hero" [ngClass]="getVariantClass()">
      <span class="alert-hero__halo"></span>
      <span class="alert-hero__ring"></span>
      <span class="alert-hero__icon-wrap">
        <i [class]="getIconByType()"></i>
      </span>
    </div>

    <div class="alert-content">
      <h2>{{ title || getDefaultTitle() }}</h2>
      <p>{{ message }}</p>
    </div>

    <div class="alert-actions" *ngIf="decision">
      <button type="button" class="alert-button alert-button--ghost" (click)="onCancel.emit()">
        Cancelar
      </button>
      <button type="button" class="alert-button alert-button--primary" (click)="onConfirm.emit()">
        Aceptar
      </button>
    </div>

    <div class="alert-actions alert-actions--single" *ngIf="!decision">
      <button type="button" class="alert-button alert-button--primary" (click)="onCancel.emit()">
        Entendido
      </button>
    </div>
  </div>
</div>
